import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ArrowBackIosIcon from 'components/material-symbol/icons/ArrowBackIos'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
  },
  pageHeaderMain: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  backButton: {
    color: '#001C57',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(-0.5),
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  eventSubtitle: {
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.25),
  },
  pageTitle: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#001C57',
    lineHeight: 1.2,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.spacing(0.5),
  },
}))

const SubviewPageHeader = ({
  eventTitle,
  pageTitle,
  onBack,
  actions = null,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.pageHeader}>
      <Box className={classes.pageHeaderMain}>
        <Box
          className={classes.backButton}
          onClick={onBack}
          role="button"
          tabIndex={0}
          aria-label="Back"
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onBack()
            }
          }}
        >
          <ArrowBackIosIcon fontSize="small" />
        </Box>
        <Box className={classes.titleBlock}>
          {eventTitle ? (
            <Typography className={classes.eventSubtitle}>
              {eventTitle}
            </Typography>
          ) : null}
          <Typography className={classes.pageTitle}>{pageTitle}</Typography>
        </Box>
      </Box>
      {actions ? <Box className={classes.headerActions}>{actions}</Box> : null}
    </Box>
  )
}

export default SubviewPageHeader
